<div class="row shop-system-container">
    <div class="col-12 align-items-center">
        <app-search-and-select #appSearchAndSelectComponent
                               [data]="customers"
                               [total]="total"
                               
                               [searchLabel]="'Axilla.ShopSystem.Search'"
                               (onRowSelect)="onRowSelect($event)"
                               (onRowUnselect)="onRowUnselect($event)"
                               (onPagination)="onPagination($event)"
                               (onSearch)="onSearchChange($event)"></app-search-and-select>
    </div>
</div>
